import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Container } from "@material-ui/core";
import { OrderContext } from "../../context";
import theme from "../../theme";
import { getTotalPriceStr } from "../../helpers";
import styled from "styled-components";

const useStyles = makeStyles({
    table: {
        maxWidth: 650,
        padding: theme.spacing(1),
        marginLeft: "auto",
        marginRight: "auto",
    },
});

export default function SimpleTable() {
    const classes = useStyles();
    const { orders, setOrders } = React.useContext(OrderContext);

    const handleChangeQuantity = (id, direction) => () => {
        const newOrders = [...orders];
        const index = newOrders.findIndex((o) => o.id === id);
        if (index < 0) return;
        const target = newOrders[index];

        switch (direction) {
            case "plus":
                target.quantity += 1;
                setOrders(newOrders);
                break;

            case "minus":
                if (target.quantity > 1) {
                    target.quantity -= 1;
                } else {
                    newOrders.splice(index, 1);
                }
                setOrders(newOrders);
                break;

            default:
                break;
        }
    };

    const rows = orders
        ? orders.map((row) => (
              <TableRow key={row.name}>
                  <TableCell align="center">{row.id}</TableCell>
                  <TableCell align="center">{row.name}</TableCell>
                  <TableCell align="center">{row.price}</TableCell>
                  <TableCell align="center">
                      <RoundBtn onClick={handleChangeQuantity(row.id, "plus")}>
                          +
                      </RoundBtn>
                      {row.quantity}
                      <RoundBtn onClick={handleChangeQuantity(row.id, "minus")}>
                          -
                      </RoundBtn>
                  </TableCell>
              </TableRow>
          ))
        : null;

    return (
        <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell align="center">ID</TableCell>
                        <TableCell align="center">Name</TableCell>
                        <TableCell align="center">Einzelpreis</TableCell>
                        <TableCell align="center">Menge</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows}
                    <TableRow>
                        <TableCell />
                        <TableCell />
                        <TableCell align="center">
                            <b>Gesamt</b>
                        </TableCell>
                        <TableCell align="center">
                            {getTotalPriceStr(orders)}
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
}

const RoundBtn = styled.button`
    border-radius: 30%;
    border: 0px;
    margin: 1rem;
    text-align: center;
`;
